import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
import { Alert, Box } from "@mui/material";
// redux
import { useDispatch, useSelector } from "../../redux/store";
// hooks
import useSettings from "../../hooks/useSettings";
import useResponsive from "../../hooks/useResponsive";
import useCollapseDrawer from "../../hooks/useCollapseDrawer";
// config
import { HEADER, NAVBAR } from "../../config";
//
import DashboardHeader from "./header";
import NavbarVertical from "./navbar/NavbarVertical";
import NavbarHorizontal from "./navbar/NavbarHorizontal";
import jwtDecode from "jwt-decode";
import AdminBanner from "src/components/global/AdminBanner";
import HealthCheck from "src/components/global/HealthCheck";
import Notification from "src/components/global/Notification";
import useLocales from "src/hooks/useLocales";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import i18next from "i18next";
import { t } from "i18next";

// Extend Day.js with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

// Get user's timezone
// ----------------------------------------------------------------------

const MainStyle = styled("main", {
  shouldForwardProp: (prop) => prop !== "collapseClick",
})(({ collapseClick, theme }) => ({
  // paddingTop: HEADER.MOBILE_HEIGHT,
  paddingBottom: HEADER.MOBILE_HEIGHT + 24,
  [theme.breakpoints.up("lg")]: {
    // paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    transition: theme.transitions.create("margin-left", {
      duration: theme.transitions.duration.shorter,
    }),
    ...(collapseClick && {
      marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
    }),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { collapseClick, isCollapse } = useCollapseDrawer();
  const { translate } = useLocales()
  const { horse } = useSelector((state) => state.horse);
  const { user } = useSelector(state => state.user)
  const [open, setOpen] = useState(false);
  const [showBanner, setShowBanner] = useState(false)
  const userTZ = dayjs.tz.guess();

  const isDesktop = useResponsive("up", "lg");

  const token = localStorage.getItem('accessToken')

  const notification_end_time = dayjs.utc("06/03/2025 23:00", "DD/MM/YYYY HH:mm").tz(userTZ)
  const notification_start_time = dayjs.utc("06/03/2025 18:45", "DD/MM/YYYY HH:mm").tz(userTZ)

  // Assuming `notification_end_time` is a dayjs object
  const formattedStartTime = notification_start_time.format("hh:mm A");
  const formattedEndTime = notification_end_time.format("hh:mm A");


  useEffect(() => {
    if (!token) return

    let decode = jwtDecode(token)

    if ('iu' in decode) {
      setShowBanner(true)
    }

  }, [token])

  return (
    <Box
      sx={{
        display: { lg: "flex" },
        flexDirection: 'column',
        minHeight: { lg: 1 },
      }}
    >
      <Box className="header-wrapper" position={'sticky'} zIndex={1001} top={0} display={'flex'} flexDirection={'column'} width={'100%'}>
        <Notification
          message={translate('notification.disabledSyncMsg', {
            start: formattedStartTime,
            end: formattedEndTime
          })}
          severity={'info'}
          cancelDate={notification_end_time}
        />
        <HealthCheck />
        <DashboardHeader
          isCollapse={isCollapse}
          withNavbar={horse && true}
          onOpenSidebar={() => setOpen(true)}
        />

        {!isDesktop && (
          <NavbarVertical
            isOpenSidebar={open}
            onCloseSidebar={() => setOpen(false)}
          />
        )}
      </Box>
      <MainStyle collapseClick={collapseClick}>
        <Box sx={{ position: 'sticky', top: 60, display: 'flex', flexDirection: 'column', zIndex: 999 }}>
          {
            showBanner && <AdminBanner></AdminBanner>
          }
        </Box>
        <Box sx={{ px: 2, py: 3 }}>
          <Outlet />
        </Box>
      </MainStyle >
    </Box >
  );
}
